export default __webpack_public_path__ + "static/media/maintenance.1df793ac.png";